import React from "react";
import { useTranslation } from "react-i18next";

import { getDeviceScreenType } from "@utils/DeviceInfoUtils";

import { Feature1, Feature2, Feature3, MobileWITPGroupPic, WitpGuestCourse } from "@assets/index";

import PrimaryButton from '@components/atoms/Button/PrimaryButton';
import { Img } from "@components/Image";
import { groupSetting } from '@components/molecules/Slider/SettingConstant';
import MultipleSlider from "@components/Slider/MultipleSlider";
import Text, { FontFamilyVariant, TextType } from '@components/Text';

import navigator from '@navigator/index';
import { NavigationUrl, URLs } from "@navigator/NavigationUrl";

import "./styles.less";
interface IProps {

}

const GuestOverview = (props: IProps) => {
    const { t } = useTranslation();

    const featureArray = [{
        id: 1,
        icon: <Img src={Feature1} alt="Feature Icon" />,
        description: t("guestView.labelsAndTitles.GUEST_CARD_ONE"),
        backgroundColor: "#ecd9d5"
    },
    {
        id: 2,
        icon: <Img src={Feature2} alt="Feature Icon" />,
        description: t("guestView.labelsAndTitles.GUEST_CARD_TWO"),
        backgroundColor: "#e2cad4"
    },
    {
        id: 3,
        icon: <Img src={Feature3} alt="Feature Icon" />,
        description: t("guestView.labelsAndTitles.GUEST_CARD_THREE"),
        backgroundColor: "#ecd9d5"
    }];

    const goToLogin = () => {
        navigator.push(NavigationUrl.generate(URLs.login));
    }

    const featureCard = (feature) => {
        return (
            <div className="guest_feature_card__container" style={{ backgroundColor: feature?.backgroundColor }} key={feature?.description}>
                {feature?.icon}
                <Text
                    className="guest_feature_card__desc"
                    textType={TextType.paragraph1}
                    fontFamilyVariant={FontFamilyVariant.regular}
                    text={feature?.description}
                />
            </div>
        )
    }

    return (
        <>
            <div className="guest_overview__container">
                <div className="guest_overview__title_container">
                    <Text
                        className="guest_overview__title"
                        textType={TextType.h1}
                        fontFamilyVariant={FontFamilyVariant.bold}
                        text={t("guestView.labelsAndTitles.COURSE_POINT_ONE")}
                    />
                    <Text
                        className="guest_overview__desc"
                        textType={TextType.paragraph1}
                        fontFamilyVariant={FontFamilyVariant.bold}
                        text={t("guestView.labelsAndTitles.COURSE_POINT_TWO")}
                    />
                </div>
                <PrimaryButton
                    className="guest_overview__btn"
                    htmlType="submit"
                    onClick={goToLogin}
                >
                    {t('guestView.actions.GET_STARTED')}
                </PrimaryButton>
            </div>
            <div className="guest_feature_card__section_container">
                {featureArray?.map((feature) => {
                    return (
                        featureCard(feature)
                    )
                })}
            </div>
            <div className="guest_feature_card__section_mobile_container">
                <MultipleSlider customSetting={groupSetting}>
                    {featureArray?.concat(null)?.map((feature, index) => {
                        if (!feature) {
                            return null;
                        }
                        return featureCard(feature);
                    })}
                </MultipleSlider>
            </div>
            <Img src={getDeviceScreenType() !== "xs" ? WitpGuestCourse : MobileWITPGroupPic} alt="photo" className="guest_overview__image" />
        </>

    )
}

export default GuestOverview;

